import {
  Button,
  BUTTON_VARIANTS,
  IconArrowForward,
  IconArrowBack,
} from 'cdk-radial';
import React, { useEffect } from 'react';
import './OrderAPIStepperFooter.scss';
import {
  AMPLITUDE_EVENTS,
  AMPLITUDE_PROPERTIES,
} from '../../../../../constants/amplitudeConstants';
import {
  getOrgAmplitudeProperties,
  sendAmplitudeData,
} from '../../../../../utils/amplitude';
import { useSelector } from 'react-redux';
import {
  API_TYPES,
  ORDER_APIS_STEPPER_FOOTER,
} from '../../../../../constants/APIDirectoryConstants';
import { useHistory } from 'react-router-dom';
import {
  Constants,
  MSA_CONSENT_STATUS,
  RESOURCE_TYPES,
} from '../../../../../constants/constants';
import { setScreen } from '../../../../../redux/connectedComponent/uiFactory/uiFactory.slice';
import { screens } from '../../../../config/uiFactory.config';
import { useDispatch } from 'react-redux';
import { getConsentPayload } from '../../../../../utils/utils';
import {
  createOrder,
  deleteApiDetails,
  getStampedTermsDocuments,
} from '../../../../../redux/connectedComponent/orderAPI/orderAPI.slice';
import { getConsentTerms } from '../../../../../redux/connectedComponent/apiDirectory/apiDirectory.slice';
import { trackReviewedCart, getCartPricingDetails } from '../../../../../utils/gtm';

const OrderAPIStepperFooter = ({
  setActiveStep,
  activeStep,
  isContinueDisabled,
  step,
  handleCompletePurchase,
  cart: cartProp,
}) => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const cart = cartProp || state?.orderAPISlice?.cart;
  const creatingOrder = state?.orderAPISlice?.creatingOrder;
  const updatingOrder = state?.orderAPISlice?.updatingOrder;
  const savingBundleConsents = state?.orderAPISlice?.savingBundleConsents;
  const {
    selectedApiPricing,
    orders,
    selectedFieldsMapping,
    obsoleteApisInCart,
    orderCreated,
    orderUpdated,
    stampedTermsDocuments,
  } = state?.orderAPISlice;
  const {
    isAuthenticated,
    fortellisEnterpriseEntityId,
    decodedToken: { firstName, lastName, cid: userId } = {},
    userEmail,
    authenticationToken: token,
    hasDAABAccess,
    entityDetails
  } = state?.loginDetailsSlice;
  const orgAmplitudeProperties = getOrgAmplitudeProperties(
    state?.loginDetailsSlice
  );
  const { daabConsentDetails } = state.apiDirectorySlice;
  const isMsaConsented =
    daabConsentDetails?.consentStatus === MSA_CONSENT_STATUS.CONSENTED;
  const isAppErrorProvisioning =
    orders?.app?.status === Constants.APP_STATUSES.PROVISIONING ||
    orders?.app?.status === Constants.APP_STATUSES.ERROR;
  const history = useHistory();
  const authProp = {
    isAuthenticated,
    userData: {
      name: `${firstName || ''} ${lastName || ''}`,
      email: userEmail,
    },
  };
  useEffect(() => {
    if (orderCreated || orderUpdated) {
      let totalCartItems = cart.concat(obsoleteApisInCart);
      const pricingDetails = getCartPricingDetails(cart);
      const bundleItemsCount = cart.filter((x) => x.resourceType?.toLowerCase() === RESOURCE_TYPES.BUNDLE).length;
      const apiItemsCount = cart.length - bundleItemsCount;
      // Store purchase details for GTM event tracking when polling is complete
      sessionStorage.setItem('pendingPurchaseTracking', JSON.stringify({
        totalPrice: pricingDetails.totalBill,
        totalInstallFee: pricingDetails.totalInstallFee,
        apiItemsSize: apiItemsCount,
        bundleCartSize: bundleItemsCount
      }));

      const resourceIds = totalCartItems.map((item) => item.resourceId).join(',');
      dispatch(
        deleteApiDetails({
          entityId: fortellisEnterpriseEntityId,
          token,
          resourceIds
        })
      );
      history.push('/dp/my-apis');
      dispatch(setScreen({ screen: screens.MY_APIS }));
    }
  }, [orderCreated, orderUpdated]);

  useEffect(() => {
    if (
      daabConsentDetails &&
      !hasDAABAccess &&
      Object.keys(daabConsentDetails).length <= 0
    ) {
      dispatch(getConsentTerms({ token }));
    }
  });

  const handleForword = async () => {
const bundleNames = Array.isArray(cart)
  ? cart
      .filter(
        (item) => item.resourceType?.toLowerCase() === RESOURCE_TYPES.BUNDLE,
      )
      .map((item) => item?.details?.name)
  : [];

const appName =
  orders?.app?.name || `${fortellisEnterpriseEntityId}_dealer_Api_integrations`;
    
    if (step !== ORDER_APIS_STEPPER_FOOTER.REVIEW_TERMS) {
      setActiveStep(activeStep + 1);
    }
    if (step === ORDER_APIS_STEPPER_FOOTER.REVIEW_APIS) {
      const pricingDetails = getCartPricingDetails(cart);
      const bundleItemsCount = cart.filter((x) => x.resourceType?.toLowerCase() === RESOURCE_TYPES.BUNDLE).length;
      const apiItemsCount = cart.length - bundleItemsCount;
      trackReviewedCart(pricingDetails.totalBill, pricingDetails.totalInstallFee, apiItemsCount, bundleItemsCount);

      sendAmplitudeData(
        AMPLITUDE_EVENTS.REVIEW_CART_CONTINUE,
        orgAmplitudeProperties
      );
    }

    if (step === ORDER_APIS_STEPPER_FOOTER.REVIEW_APIS) {
      const uniqueBundleNames = [...new Set(bundleNames.filter(Boolean))];
      const fetchedBundleNames = new Set(
        (stampedTermsDocuments || [])
          .map((doc) => doc?.bundleName?.toLowerCase())
          .filter(Boolean)
      );
      const bundleNamesToFetch = uniqueBundleNames.filter(
        (bundleName) => !fetchedBundleNames.has(bundleName.toLowerCase())
      );

      if (bundleNamesToFetch.length > 0) {
        const BATCH_SIZE = 10;
        for (let i = 0; i < bundleNamesToFetch.length; i += BATCH_SIZE) {
          const batchedBundleNames = bundleNamesToFetch.slice(i, i + BATCH_SIZE);
          dispatch(
            getStampedTermsDocuments({
              orgName: entityDetails?.organizationName,
              orgId: fortellisEnterpriseEntityId,
              appName,
              bundleNames: batchedBundleNames,
              consentingDealerUser: authProp?.userData?.name,
              firstName,
              lastName,
              userId,
              email: userEmail,
              token,
            }),
          );
        }
      }
    }

    if (step === ORDER_APIS_STEPPER_FOOTER.REVIEW_TERMS) {
      sendAmplitudeData(
        AMPLITUDE_EVENTS.TERMS_COMPLETE_PURCHASE,
        orgAmplitudeProperties
      );
      await handleCompletePurchase();
    }
  };
  const handleBack = () => {
    if (step === ORDER_APIS_STEPPER_FOOTER.REVIEW_TERMS) {
      sendAmplitudeData(AMPLITUDE_EVENTS.TERMS_BACK, orgAmplitudeProperties);
    }
    if (activeStep >= 2) setActiveStep(activeStep - 1);
  };
  const getSelectedApiFields = (apiFields) => {
    const results = {};

    for (const key in selectedFieldsMapping) {
      const instances = apiFields[key] ? Object.keys(apiFields[key]) : [];
      const requiredFields = selectedFieldsMapping[key];

      instances.forEach((instance) => {
        const fields = apiFields[key][instance].fields;
        const fieldArray = [];

        requiredFields.forEach((requiredField) => {
          const matchingField = fields.find(
            (field) => field.name === requiredField
          );
          if (matchingField) {
            fieldArray.push({ name: requiredField, required: false });
          }
        });

        if (fieldArray.length > 0) {
          results[key] = results[key] || {};
          results[key][instance] = fieldArray;
        }
      });
    }
    return results;
  };

  return (
    <div className="payment-stepper-navigation">
      {activeStep !== 1 && (
        <Button
          dataTestId="button"
          icon={<IconArrowBack />}
          iconColor="gray"
          iconSize={24}
          onClick={handleBack}
          size="standard"
          text="Back"
          variant={BUTTON_VARIANTS.SECONDARY}
        />
      )}

      <Button
        dataTestId="continue-button"
        iconColor="gray"
        iconSize={24}
        onClick={handleForword}
        isDisabled={
          isContinueDisabled ||
          (step === ORDER_APIS_STEPPER_FOOTER.REVIEW_TERMS &&
            isAppErrorProvisioning) ||
          (!isMsaConsented && !hasDAABAccess)
        }
        step={step}
        size="standard"
        text={
          step === ORDER_APIS_STEPPER_FOOTER.REVIEW_TERMS
            ? Constants.COMPLETE_PURCHASE
            : Constants.CONTINUE
        }
        variant="primary"
        isLoading={
          step === ORDER_APIS_STEPPER_FOOTER.REVIEW_TERMS &&
          (creatingOrder === true || updatingOrder === true || savingBundleConsents === true)
        }
        style={{
          width:
            step === ORDER_APIS_STEPPER_FOOTER.REVIEW_TERMS ? '160px' : 'auto',
        }}
      />
    </div>
  );
};
export default OrderAPIStepperFooter;
